import { render, staticRenderFns } from "./CVManagerViewPage.vue?vue&type=template&id=5df5f604&scoped=true&"
import script from "./CVManagerViewPage.vue?vue&type=script&lang=js&"
export * from "./CVManagerViewPage.vue?vue&type=script&lang=js&"
import style0 from "./CVManagerViewPage.vue?vue&type=style&index=0&id=5df5f604&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df5f604",
  null
  
)

export default component.exports